module.exports = __webpack_public_path__ + "static/media/01_pre-enrollment-prep.7311d8e7.svg";